import { Serializers, SerializerValue } from "@megaron/serializers";

export const itemsSortFields = ["box", "pallet", "layer", "size", "gtin"] as const;
export type ItemSortField = (typeof itemsSortFields)[number];

export const itemFiltersSerializer = Serializers.object({
  searchText: Serializers.string,
  sort: Serializers.sortFilter(itemsSortFields).asJsonString(),
  isLoyalty: Serializers.boolean.asJsonString(),
  groups: Serializers.string.array().asJsonString(),
  isArchived: Serializers.boolean.asJsonString(),
  isInAvailability: Serializers.boolean.asJsonString(),
}).partial();

export type ItemFilters = SerializerValue<typeof itemFiltersSerializer>;
